import React, { useEffect, useState } from "react";

import { SearchParams } from "../../atomic_components/types";
import { AppDispatch } from "../../state";
import { useDispatch } from "react-redux";
import { ActiveTab__Action } from "../../state/action-creators";
import { useAppSelector } from "../../state/hooks";
import { useHistory, useParams } from "react-router-dom";
import CataloguesAdd from "./CataloguesAdd";
import CataloguesAll from "./CataloguesOneTime";
import CataloguesStandard from "./CataloguesStandard";
import CataloguesOneTime from "./CataloguesOneTime";

interface RouteParams {
  category: string; // Define the type for the parameter you're expecting
}

function CataloguesHome() {
  const dispatch: AppDispatch = useDispatch();
  const history = useHistory();
  useEffect(() => {
    dispatch(ActiveTab__Action("catalogues"));
  }, []);

  const { category } = useParams<RouteParams>();
  const [selectedItem, setSelectedItem] = useState(category);
  const handleItemClick = (item: string) => {
    setSelectedItem(item);
    history.push(`/catalogues/${item}`);
  };

  useEffect(() => {
    console.log(category);
    setSelectedItem(category);
  }, [category]);

  return (
    <div>
      <div className="nav-container">
        <nav className="navbar-vendors">
          <ul className="navbar-menu">
            <li
              className={`navbar-item ${
                selectedItem === "standard" ? "active" : ""
              }`}
              onClick={() => handleItemClick("standard")}
            >
              Standard Catalogues
            </li>
            <li
              className={`navbar-item ${
                selectedItem === "onetime" ? "active" : ""
              }`}
              onClick={() => handleItemClick("onetime")}
            >
              One-Time Catalogues
            </li>
            <li
              className={`navbar-item ${
                selectedItem === "add" ? "active" : ""
              }`}
              onClick={() => handleItemClick("add")}
            >
              Create new Catalogue
            </li>
          </ul>
        </nav>
      </div>

      {selectedItem == "standard" && <CataloguesStandard />}
      {selectedItem == "onetime" && <CataloguesOneTime />}
      {selectedItem == "add" && <CataloguesAdd />}
    </div>
  );
}

export default CataloguesHome;
